import { render } from "./chat-helpdesk.vue?vue&type=template&id=48a62d79&scoped=true"
import script from "./chat-helpdesk.vue?vue&type=script&lang=js"
export * from "./chat-helpdesk.vue?vue&type=script&lang=js"

import "./chat-helpdesk.vue?vue&type=style&index=0&id=48a62d79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a62d79"]])

export default __exports__